import callAPiBase from './base';

const sellingPointsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sellingPointList',
      method: 'GET',
      useToken: true,
      title: 'Selling Points - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingPointCreate',
      method: 'POST',
      useToken: true,
      title: 'Selling Points - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingPointUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Selling Points - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sellingPointDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Selling Points - Delete',
      params,
    }),
  addPayment: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingPointAddPayment',
      method: 'POST',
      useToken: true,
      title: 'Selling Points - Add Payment',
      data,
    }),
  changePassword: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingPointResetPassword ',
      method: 'PATCH',
      useToken: true,
      title: 'Change Password Full',
      data,
    }),
};

export { sellingPointsApi };
export default sellingPointsApi;
